<template>
	<div :style="{ background: background }" class="item-list">
		<p
			v-for="(item, index) in items"
			:key="getItemKey(item, index)"
			class="item-list__item"
		>
			<span class="item-list__icon">
				<v-icon
					:color="getItemIconColor(item)"
					:size="Number(iconSize)"
					>{{ getItemIcon(item) }}</v-icon
				>
			</span>
			<span class="item-list__text" v-html="getItemText(item)" />
		</p>
	</div>
</template>

<script>
export default {
	props: {
		icon: {
			default: "info",
			type: String
		},
		iconColor: {
			default: "primary",
			type: String
		},
		iconSize: {
			default: undefined,
			type: [Number, String]
		},
		items: {
			type: Array,
			required: true
		},
		background: {
			type: String,
			default: "transparent"
		}
	},
	methods: {
		getItemIcon(item) {
			if (item.icon) {
				return item.icon;
			}
			return this.icon;
		},
		getItemIconColor(item) {
			if (item.iconColor) {
				return item.iconColor;
			}
			return this.iconColor;
		},
		// Support both raw strings, and objects containing a text property
		getItemText(item) {
			if (item.text) {
				return item.text;
			}
			return item;
		},
		getItemKey(item, index) {
			// This weird logic exists, to support user defined item keys in
			// the input item list, it is prefixed with a prefix, to prevent
			// conflicts between user specified keys, and automaticly generated keys
			if (item.key) {
				return `user-${item.key}`;
			}
			return `index-${index}`;
		}
	}
};
</script>

<style>
.item-list {
	width: 100%;
	display: inline-block;
	border-radius: 3px;
}
@supports (display: block) {
	.item-list {
		width: auto;
	}
}
.item-list__item {
	margin: 0 0 15px 0;
	display: flex;
}
.item-list__icon {
	width: 32px;
	user-select: none;
}
.item-list__text {
	flex: 1;
}
</style>
